<template>
  <div>
    <div id="toprow" class="topHeader">
      <div class="tw-w-6 tw-h-6 tw-ml-4">
        <img
          v-if="isAuthenticated && hasRoles"
          src="@/assets/hamburger_white.svg"
          @click="() => this.$emit('displaySidebar', true)"
        />
      </div>
      <div class="tw-h-6">
        <img
          fill="currentColor"
          class="tw-text-white logo"
          src="@/assets/MySideline_MobileLogo_white.svg"
          alt="My Sideline"
        />
      </div>
      <div class="tw-w-12"></div>
    </div>
    <div
      v-if="headerName"
      id="bottomRow"
      class="tw-bg-white tw-shadow-md tw-flex tw-items-center tw-py-4 tw-m-0 tw-text-black tw-h-14 tw-text-xl tw-uppercase tw-pl-4 tw-tracking-widest"
    >
      <h2
        :key="headerName"
        class="tw-flex-1 tw-text-22px tw-leading-22px tw-font-medium tw-tracking-widest tw-text-left"
      >
        {{ headerName }} <span class="tw-text-green-300">/</span>
      </h2>

      <button v-if="isAuthenticated && !hasRoles" type="secondary" @click="clickLogout">
        Log Out
      </button>

      <div class="dropdown" v-if="headerMenu && headerMenu.length">
        <img src="@/assets/options.svg" class="tw-w-8 tw-h-8 dropbtn" @click="clickHeaderMenu" />
        <div
          v-if="showDropDown"
          id="myDropdown"
          class="dropdown-content tw-top-8 tw-right-0 tw-bg-white tw-text-sm tw-text-gray-600"
          :class="showDropDown ? 'show' : ''"
        >
          <a href="#" @click="clickHeaderMenu('go-team-list')">Go to teamlist</a>
          <a href="#" @click="clickHeaderMenu('dispute-match')">Dispute match</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "NavBar",
  components: {},
  props: {},
  data() {
    return {
      displayUserRoles: false,
      showDropDown: false,
    };
  },
  mounted() {},
  computed: {
    hasRoles() {
      return this.$store.getters["user/roles"] && this.$store.getters["user/roles"].length > 0;
    },
    isAuthenticated() {
      return this.$store.getters["user/isAuthenticated"];
    },
    myname() {
      return this.$store.getters["user/userName"];
    },
    headerName() {
      return this.$route.meta.displayName;
    },
    headerMenu() {
      return this.$route.meta.headerMenu || [];
    },
  },
  methods: {
    clickHeaderMenu(type) {
      this.showDropDown = !this.showDropDown;
      this.$root.$emit(`${this.$route.name}-header-menu`, type);
    },
    clickLogout() {
      this.$store.commit("user/logout");
      this.$router.push("/login");
    },
  },
};
</script>

<style>
.topHeader {
  @apply tw-flex tw-flex-row tw-items-center tw-justify-between tw-h-12 tw-pt-3 tw-pb-3 tw-bg-black;
}
</style>

<style scoped lang="scss">
.logo {
  height: 25px;
  padding-left: 20px;
}

.switch-role {
  letter-spacing: 0.2em;
}

.no-roles-logout {
  display: flex;
  justify-content: flex-end;
  .el-button {
    margin-right: 1rem;
  }
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  background-color: #ddd;
}

/* Show the dropdown menu (use JS to add this class to the .dropdown-content container when the user clicks on the dropdown button) */
.show {
  display: block;
}
</style>
